import { v4 as uuid } from "uuid";

export const CUSTOMIZER_TABS = {
  CATEGORY_CONFIG: 0,
  PREVIEW: 1,
  PORTAL_CONFIG: 2,
};

export const quickActionsTooltipProps = {
  delay: 500,
  position: "mouse",
  hideTooltipOnMouseDown: true,
};

export const LOCAL_STORAGE_SELECTED_CUSTOMIZER_TAB_KEY =
  "caelorShopCustomizerActiveTabIndex";

export const LOCAL_STORAGE_CARTS_KEY = "caelorShopLocalCarts";

export const LOCAL_STORAGE_CATALOG_DRAFT_PREFIX_FOR_ID =
  "caelorShopCustomizerDraftForCatalog";
